import { SEO } from '../../lib/seo';

export function HomePageSEO() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "TheViewShed - Line-of-Sight Views Directory",
    "description": "A community driven visual directory of line-of-sight views from around the world. Discover and share remarkable vistas, viewpoints, and visual connections between landmarks.",
    "url": "https://theviewshed.com/",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Line-of-Sight Views Directory",
          "url": "https://theviewshed.com/"
        }
      ]
    }
  };

  return (
    <SEO
      title="Home | TheViewShed"
      description="Explore our community-driven directory of remarkable line-of-sight views, panoramas, and visual connections between landmarks worldwide."
      keywords="viewshed, line of sight, views, vistas, mountain views, panorama, landscape, viewpoints, distance views, visual connections, landmarks, directory"
      structuredData={structuredData}
    />
  );
} 